export const sportColors = {
	"football": "#427da5",
	"basketball": "#ffb332",
	"cricket": "#fd672f",
	"golf": "#bcd039",
	"martial arts": "#ffdf00",
	"athletics": "#f81859",
	"rugby": "#f233e0",
	"baseball": "#b2409c",
	"motorsports": "#18c6b1",
	"other": "#3b8e2f",
	"no data": "#615e6b",
}

export const data = [{
	"title": "Curaçao",
	"id": "CW",
	"sport": "baseball",
	"sport2": "baseball"
}, {
	"title": "Dominican Republic",
	"id": "DO",
	"sport": "baseball",
	"sport2": "baseball"
}, {
	"title": "Nicaragua",
	"id": "NI",
	"sport": "baseball",
	"sport2": "baseball"
}, {
	"title": "Lithuania",
	"id": "LT",
	"sport": "basketball",
	"sport2": "basketball"
}, {
	"title": "USA",
	"id": "US",
	"sport": "basketball",
	"sport2": "basketball"
}, {
	"title": "Norway",
	"id": "NO",
	"sport": "other",
	"sport2": "other"
}, {
	"title": "Afghanistan",
	"id": "AF",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Antigua and Barbuda",
	"id": "AG",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Bahrain",
	"id": "BH",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "India",
	"id": "IN",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Maldives",
	"id": "MV",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "New Zealand",
	"id": "NZ",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Oman",
	"id": "OM",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Qatar",
	"id": "QA",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Saudi Arabia",
	"id": "SA",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "St Kitts and Nevis",
	"id": "KN",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "United Arab Emirates",
	"id": "AE",
	"sport": "cricket",
	"sport2": "cricket"
}, {
	"title": "Ethiopia",
	"id": "ET",
	"sport": "football",
	"sport2": "athletics"
}, {
	"title": "Panama",
	"id": "PA",
	"sport": "football",
	"sport2": "baseball"
}, {
	"title": "Venezuela",
	"id": "VE",
	"sport": "football",
	"sport2": "baseball"
}, {
	"title": "Algeria",
	"id": "DZ",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Armenia",
	"id": "AM",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Azerbaijan",
	"id": "AZ",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Benin",
	"id": "BJ",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Bosnia and Herzegovina",
	"id": "BA",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Burkina Faso",
	"id": "BF",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Cape Verde Islands",
	"id": "CV",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Chile",
	"id": "CL",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Congo",
	"id": "CG",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Côte d'Ivoire",
	"id": "CI",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Croatia",
	"id": "HR",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Cyprus",
	"id": "CY",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Egypt",
	"id": "EG",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "FYR Macedonia",
	"id": "MK",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Gabon",
	"id": "GA",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Georgia",
	"id": "GE",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Greece",
	"id": "GR",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Guinea-Bissau",
	"id": "GW",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Haiti",
	"id": "HT",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Hong Kong",
	"id": "HK",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Iraq",
	"id": "IQ",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Jordan",
	"id": "JO",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Kazakhstan",
	"id": "KZ",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Kenya",
	"id": "KE",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Latvia",
	"id": "LV",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Lebanon",
	"id": "LB",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Mali",
	"id": "ML",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Montenegro",
	"id": "ME",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Morocco",
	"id": "MA",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Palestine",
	"id": "PS",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Senegal",
	"id": "SN",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Slovenia",
	"id": "SI",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Uruguay",
	"id": "UY",
	"sport": "football",
	"sport2": "basketball"
}, {
	"title": "Faroe Islands",
	"id": "FO",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "China",
	"id": "CN",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Congo DR",
	"id": "CD",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "United Kingdom",
	"id": "GB",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Jamaica",
	"id": "JM",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Lesotho",
	"id": "LS",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Libya",
	"id": "LY",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Malawi",
	"id": "MW",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Sierra Leone",
	"id": "SL",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "South Africa",
	"id": "ZA",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Trinidad and Tobago",
	"id": "TT",
	"sport": "football",
	"sport2": "cricket"
}, {
	"title": "Belarus",
	"id": "BY",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "Russia",
	"id": "RU",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "Albania",
	"id": "AL",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Andorra",
	"id": "AD",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Equatorial Guinea",
	"id": "GQ",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "France",
	"id": "FR",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Guinea",
	"id": "GN",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Iceland",
	"id": "IS",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Israel",
	"id": "IL",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Luxembourg",
	"id": "LU",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Republic of Ireland",
	"id": "IE",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Serbia",
	"id": "RS",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "South Korea",
	"id": "KR",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Tunisia",
	"id": "TN",
	"sport": "football",
	"sport2": "golf"
}, {
	"title": "Botswana",
	"id": "BW",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Angola",
	"id": "AO",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Rwanda",
	"id": "RW",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Tanzania",
	"id": "TZ",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Ecuador",
	"id": "EC",
	"sport": "football",
	"sport2": "athletics"
}, {
	"title": "Turkmenistan",
	"id": "TM",
	"sport": "football",
	"sport2": "athletics"
}, {
	"title": "Kyrgyzstan",
	"id": "KG",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Myanmar",
	"id": "MM",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Tajikistan",
	"id": "TJ",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Ukraine",
	"id": "UA",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Uzbekistan",
	"id": "UZ",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Bolivia",
	"id": "BO",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "Costa Rica",
	"id": "CR",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "El Salvador",
	"id": "SV",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "Honduras",
	"id": "HN",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "Mozambique",
	"id": "MZ",
	"sport": "football",
	"sport2": "motorsports"
}, {
	"title": "Argentina",
	"id": "AR",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Mexico",
	"id": "MX",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Namibia",
	"id": "NA",
	"sport": "football",
	"sport2": "rugby"
}, {
	"title": "Yemen",
	"id": "YE",
	"sport": "football",
	"sport2": "athletics"
}, {
	"title": "Bulgaria",
	"id": "BG",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Hungary",
	"id": "HU",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Portugal",
	"id": "PT",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Romania",
	"id": "RO",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Thailand",
	"id": "TH",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Niger",
	"id": "NE",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Burundi",
	"id": "BI",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Cameroon",
	"id": "CM",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Central African Republic",
	"id": "CF",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Colombia",
	"id": "CO",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Comoros",
	"id": "KM",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Madagascar",
	"id": "MG",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Mauritania",
	"id": "MR",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Togo",
	"id": "TG",
	"sport": "football",
	"sport2": "other"
}, {
	"title": "Peru",
	"id": "PE",
	"sport": "football",
	"sport2": "athletics"
}, {
	"title": "Ghana",
	"id": "GH",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Nigeria",
	"id": "NG",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Swaziland",
	"id": "SZ",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Uganda",
	"id": "UG",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Zambia",
	"id": "ZM",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Zimbabwe",
	"id": "ZW",
	"sport": "football",
	"sport2": "martial arts"
}, {
	"title": "Australia",
	"id": "AU",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Austria",
	"id": "AT",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Belgium",
	"id": "BE",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Brazil",
	"id": "BR",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Canada",
	"id": "CA",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Czech Republic",
	"id": "CZ",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Denmark",
	"id": "DK",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Estonia",
	"id": "EE",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Germany",
	"id": "DE",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Italy",
	"id": "IT",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Netherlands",
	"id": "NL",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Slovakia",
	"id": "SK",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Spain",
	"id": "ES",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Sweden",
	"id": "SE",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Switzerland",
	"id": "CH",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Turkey",
	"id": "TR",
	"sport": "golf",
	"sport2": "golf"
}, {
	"title": "Taiwan",
	"id": "TW",
	"sport": "martial arts",
	"sport2": "martial arts"
}, {
	"title": "Guatemala",
	"id": "GT",
	"sport": "motorsports",
	"sport2": "motorsports"
}, {
	"title": "Paraguay",
	"id": "PY",
	"sport": "motorsports",
	"sport2": "motorsports"
}, {
	"title": "Poland",
	"id": "PL",
	"sport": "other",
	"sport2": "other"
}, {
	"title": "Finland",
	"id": "FI",
	"sport": "other",
	"sport2": "other"
}, {
	"title": "Japan",
	"id": "JP",
	"sport": "martial arts",
	"sport2": "martial arts"
}, {
	"title": "Philippines",
	"id": "PH",
	"sport": "basketball",
	"sport2": "basketball"
}, {
	"title": "Vietnam",
	"id": "VN",
	"sport": "other",
	"sport2": "other"
}];



// WEBPACK FOOTER //
// ./src/data.js